import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Businesses',
    data () {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            img_bz_url: service.imageBusinessURL,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            backgroundSize: 'contain'
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
                
                
            }
        }
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //--//settings

        //business
        setComponent(business) {
            this.business = business;
            this.panelFlag = true;
            //set has reviewed and has rated
            let reviews = this.business.business_reviews;
            reviews.forEach(function(element) {
                if(this.user.user_id == element.review_user_id){
                    this.has_reviewed = true;
                  }
            }, this);
            let rating = this.business.business_ratings;
            rating.forEach(function(element) {
                if(this.user.user_id == element.rate_user_id){
                    this.has_rated = true;
                }
            }, this);
                  
        },

        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2, // 2 for business
                save_business: this.business.business_id, //forbusiness
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('Business Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            
            })
        },
        getSearchBusiness() {
            if(this.$route.query.context != null){
            var credentials = {
                  // search_type: localStorage.getItem("cityneeds_search_type"), //use other auths here
                   search_keywords: this.$route.query.context
                  // search_city: localStorage.getItem("cityneeds_search_city")
               }
               service.searchBusiness(this, this.$route.query.context).then(function(data) {
                       if(data.body.status == 200) {
                       this.business = data.body.data;
                       }else if(data.body.status == 400) {
                       //do something here like redirect to advertised data 
                       this.search_message = "Sorry Could not get the Information of entry yet";            
                       }else{
                           this.search_message = "Sorry Could not get the Information of entry yet"; 
                       }
               })
            }else{
                this.$router.push("businesses");
             }
           
       },

        //--//settings
        trackevent: function(event){
            if(event.isTrusted){
                localStorage.setItem("cn_prv_page","businesses");//log current page
                this.preset();
            }
           
        },
        
        //reviews
        submitReview() {
            var credentials = {
                review_category: 2, //business review
                review_review: this.review.review,
                review_cnpro: 0,
                review_business: this.business.business_id,
                review_user: this.user.user_id

            }
            let navi = this.$router;
            if(credentials.review_user != null || credentials.review_review != null) {
                service.submitReview(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Review Submitted!", "Success!");
                        location.reload();
                    }else {
                        toastr.error('Sorry, could not submit Review', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        //--//reviews

        //rate
        rateBusiness() {
            var credentials = {
                rating_category: 1, //cnpro rate
                rating_rate: this.rate,
                rating_cnpro: 0,
                rating_business: this.business.business_id,
                rating_user: this.user.user_id

            }
            let navi = this.$router;
            if(credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                       // location.reload();
                    }else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        //--//rate
    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","business");//log current page
        }
       this.getSearchBusiness();
    }
}


// WEBPACK FOOTER //
// ./src/components/Business/script.js